import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getPermissions } from './Common';

// handle the private routes
const PrivateRoute = ({ component: Component, roles, ...rest }) =>
// const permist = getPermissions()

(
  <Route
    {...rest}
    render={(props) => (getPermissions() ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{ pathname: '/login', state: { from: props.location } }}
      />
    ))}
  />
);

export default PrivateRoute;
